<template>
  <div class="body" id="mainInstance" ref="body">
    <div v-if="loading" class="m-3">
      <v-skeleton-loader
          type="table"
      ></v-skeleton-loader>
    </div>
    <transition name="fade">
      <div v-if="!loading">
        <div class="content-box">
          <h3 class="content-box-header bg-custom">
            {{headerText}}
            <font-awesome-icon icon="history" class="faw"></font-awesome-icon>
          </h3>

          <div class="content-box-wrapper p-0 p-md-3">
            <div class="custom-panel m-0">
              <div class="dataTables_wrapper p-0 m-0">
                <b-table class="p-0 m-0"
                         show-empty
                         :busy="loadingData"
                         :items="dataFields"
                         :fields="fields"
                         :current-page="tablePage"
                         :per-page="perPage"
                         :sort-by.sync="sortBy"
                         :sort-desc.sync="sortDesc"
                         :sort-direction="sortDirection"
                         :sort-compare="clientSideSorting"
                         @sort-changed="sortingData"
                >

                  <template v-slot:cell(status)="data">
                    <button @click="data.toggleDetails" class="display-inline float-right v-icon theme--light">
                      <transition name="rotate" mode="out-in">
                        <component v-bind:is="!data.detailsShowing ? 'v-a' : 'v-b'"></component>
                      </transition>
                    </button>
                    <span style="line-height: 15px" v-bind:class="'bs-label ' + (
                      data.item.status_code === 'pending'    ? 'label-info' 
                      : data.item.status_code === 'done'     ? 'label-success' 
                      : data.item.status_code === 'canceled' ? 'label-warning' 
                      : data.item.status_code === 'info'     ? 'label-info' 
                      : 'label-danger')">{{data.value}}</span>
                  </template>
                  <template v-slot:cell(amount)="data">
                    {{data.value != null ? wMM((Math.round(data.value*100)).toString()).slice(0,-2) :
                      '0.'}}<small>{{data.value != null ?
                      wMM((Math.round(data.value*100)).toString()).slice(-2) : '00'}}</small><span
                      class="ml-1" style="opacity: 0.6">{{data.item.currencyId}}</span>
                  </template>
                  <template v-slot:cell(payment_system)="data">
                    {{data.value}}
                  </template>
                  <template v-slot:cell(request_date)="data">
                    {{data.value.format('YYYY-MM-DD')}}<small class="ml-1" style="opacity: 0.8">{{data.value.format('HH:mm:ss')}}</small>
                  </template>
                  <template v-slot:row-details="data">
                    <div class="pl-2 pr-2 goods-details">
                      <div class="row font-bold pt-3 d-none d-md-flex">
                        <div class="col-md-2">
                        </div>
                        <div class="col-md-2">
                          <div>{{$t('message.articul')}}: </div>
                        </div>
                        <div class="col-md-4">
                          <div>{{$t('message.title')}}:</div>
                        </div>
                        <div class="col-md-2">
                          <div>{{$t('message.price_quantity')}}:</div>
                        </div>
                        <div class="col-md-2">
                          <div>{{$t('message.total')}}:</div>
                        </div>
                      </div>
                      <div  v-for="item in data.item.data" v-bind:key="'d_'+item['g:id']">
                        <div class="row row-good">
                          <div class="col-md-2">
                            <div style="width: 80px; height: 80px;" class="float-xs-left float-sm-left float-md-right float-lg-right float-xl-right">
                              <img style="width: 100%; height: 100%" :src="item['g:image_link']" alt="" v-if="item['g:image_link']">
                            </div>
                          </div>
                          <div class="col-md-2">
                            <div class="row-good-item">
                              <div class="d-md-none d-lg-none d-xl-none mr-1">{{$t('message.articul')}}: </div>
                              {{item['g:id']}}
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="row-good-item">
                              <div class="d-md-none d-lg-none d-xl-none mr-1">{{$t('message.title')}}:</div>
                              {{item['title']}}
                            </div>
                          </div>
                          <div class="col-md-2">
                            <div class="row-good-item">
                              <div class="d-md-none d-lg-none d-xl-none mr-1">{{$t('message.price_quantity')}}:</div>
                              {{wMM((Math.round(parseFloat(item['g:price'])*100)).toString()).slice(0,-2)}}<small>
                              {{wMM((Math.round(parseFloat(item['g:price'])*100)).toString()).slice(-2)}}</small><span
                                class="ml-1" style="opacity: 0.6">{{data.item.currencyId}}</span><span class="ml-1">({{item['count']}})</span>
                            </div>
                          </div>
                          <div class="col-md-2">
                            <div class="row-good-item">
                              <div class="d-md-none d-lg-none d-xl-none mr-1">{{$t('message.total')}}:</div>

                              <span>{{wMM((Math.round(parseInt(item['count'])*parseFloat(item['g:price'])*100)).toString()).slice(0,-2)}}</span>
                              <small>{{wMM((Math.round(parseInt(item['count'])*parseFloat(item['g:price'])*100)).toString()).slice(-2)}}</small>

                              <span class="ml-1" style="opacity: 0.6">{{data.item.currencyId}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex pb-2">
                        <div class="flex-grow-1 mr-2">
                          <h4 class="d-block text-right" v-for="(item1, key1) in data.item.planProperties" v-bind:key="'1_'+data.item.request_id +'_'+key1">{{key1}}:</h4>
                          <h4 class="d-block text-right pt-3" v-if="data.item.delivery">{{$t('message.delivery')}} ({{data.item.delivery.title}}):</h4>
                        </div>
                        <div class="flex-grow-0 mr-2">
                          <h4 class="d-block text-right" v-for="(item2, key2) in data.item.planProperties" v-bind:key="'2_'+data.item.request_id +'_'+key2">{{item2}}</h4>
                          <h4 class="d-block text-right pt-3" v-if="data.item.delivery">{{wMM((Math.round(data.item.delivery.price*100)).toString()).slice(0,-2)}}<small>
                            {{wMM((Math.round(data.item.delivery.price*100)).toString()).slice(-2)}}</small><span
                              class="ml-1" style="opacity: 0.6">{{data.item.currencyId}}</span></h4>
                        </div>
                      </div>
                      <div class="w-100 text-center pb-2" v-if="data.item.comment">{{data.item.comment}}</div>
                    </div>
                  </template>
                  <div slot="table-busy" class="text-center ">
                    <b-spinner class="align-middle mr-2"></b-spinner>
                    <strong>{{$t('message.loading')}}...</strong>
                  </div>
                </b-table>
              </div>
            </div>
            <b-row class="mt-2">
              <b-col md="6">
                <span v-if="tablePage > 0 && !customId">{{$t('message.showing_entires', {n1: (perPage * (currentPage - 1) + 1), n2: (lastPageLowItems ? perPage * (currentPage) : totalRows) , n3: totalRows })}}</span>
              </b-col>
              <b-col md="6">
                <b-pagination :total-rows="totalRows" :simple="false" :per-page="perPage"
                              v-model="currentPage"
                              @input="changePage()" class="my-0"/>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import Layer0 from '../../extend_classes/Layer0'
import {VSkeletonLoader} from 'vuetify/lib'
import {BTable, BSpinner, BRow, BCol, BPagination} from 'bootstrap-vue'
import moment from "moment";
import {library} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {faHistory, faAngleDown, faAngleUp} from '@fortawesome/free-solid-svg-icons' //icon-cog, icon-envelope-o,icon-unlock-alt
library.add(faHistory, faAngleDown, faAngleUp);

const statusField = new Map([
  ['processing', 'pending'], ['new', 'pending'], ['full_filled', 'done'], ['completed', 'done'], 
  ['canceled', 'canceled'], ['unpaid', 'canceled'], ['error', 'error'], ['payment-error', 'error'],
  ['22', 'done'], ['16', 'info'],
]);

// const OPERATION_TYPE = "all";
const i18n = new window.VueI18n({
  locale: 'en-US', // set locale
  fallbackLocale: 'en-US',
  messages: {
    "en-US": {
      "message": {
        "request_id": "ID",
        "request_date": "Date / Time",
        "amount": "Amount",
        "payment_system": "Payment system / Wallet",
        "status": "Status",
        "records_per_page": "records per page",
        "showing_entires": "Showing {n1} to {n2} of {n3} entries",
        "articul": "Articul",
        "title": "Title",
        "price_quantity": "Price (Quantity)",
        "total": "Total",
        "loading": "Loading",
        "done": "done",
        "pending": "pending",
        "canceled": "canceled",
        "error": "error",
        "delivery": "Delivery"
      }
    }
  }

});
export default {
  name: 'online-order-history',
  extends: Layer0,
  i18n: i18n,
  components: {
    VSkeletonLoader,
    BSpinner,
    BTable,
    BRow,
    BPagination,
    BCol,
    FontAwesomeIcon,
    'v-a': {
      template: '<font-awesome-icon icon="angle-down" class="faw"></font-awesome-icon>',
      components:{
        FontAwesomeIcon
      }
    },
    'v-b': {
      template: '<font-awesome-icon icon="angle-up" class="faw"></font-awesome-icon>',
      components: {
        FontAwesomeIcon
      }
    }
  },
  data() {
    return {
      wMM: a => a,
      fields: [
        {
          key: 'request_id',
          label: i18n.t('message.request_id'),
          sortDirection: 'desc',
          sortable: true
        },
        {
          key: 'request_date',
          label: i18n.t('message.request_date'),
          sortable: true
        },
        {
          key: 'amount',
          label: i18n.t('message.amount'),
          sortable: true
        },
        {
          key: 'payment_system',
          label: this.showWallet ? i18n.t('message.payment_system') : i18n.t('message.payment_system').split('/')[0].trim(),
          sortable: false
        },
        {
          key: 'status',
          label: i18n.t('message.status'),
          sortable: true
        }
      ],
      dataFields: null,
      perPage: 15,
      loadingData: true,
      totalRows: 1,
      currentPage: 1,
      tablePage: -1,
      sortBy: 'request_date', //order, date, sum, status
      sortDesc: true,
      sortDirection: 'asc',
      loc_name: 'VOnlineOrderHistory'
    }
  },
  props: {
    showWallet: {
      type: Boolean,
      default: false
    },
    pos: {
      type: Boolean,
      default: false
    },
    headerText: {
      type: String
    },
    wallet: {
      type: Number
    },
    accountId: {
      required: false,
      type: Number
    },
    customId: {
      required: false,
      type: Number
    },
    //	string	Нет	Дата от которой показывать счета, в формате yyyy-mm-dd
    dateStart: {
      type: String,
      default: ""
    },
    dateEnd: {
      type: String,
      default: ""
    },
    ...Layer0.props
  },
  computed: {
    lastPageLowItems() {
      return (this.perPage * this.currentPage) < this.totalRows;
    }
  },
  methods: {
    localeChange() {
      this.changeLocaleHard();
    },
    changeLocaleHard() {
      this.fields[0].label = i18n.t('message.request_id');
      this.fields[1].label = i18n.t('message.request_date');
      this.fields[2].label = i18n.t('message.amount');
      this.fields[3].label = this.showWallet ? i18n.t('message.payment_system') : i18n.t('message.payment_system').split('/')[0].trim();
      this.fields[4].label = i18n.t('message.status');
    },
    getAp() {
      this.wMM = window.MLMSoftUICore.wearMaskMoney;
    },
    sortingData() {
      if (this.perPage< this.totalRows)
        this.changePage();
    },
    clientSideSorting(a, b, key) {
      if (key) {
        switch (this.sortBy) {
          case 'request_id':
            return a[key]-b[key];
          case 'request_date':
            return new Date(a[key])-new Date(b[key]);
          case 'amount':
            return a[key]-b[key];
        }
      }
    },
    changePage() {
      this.getInfo(this.perPage, this.currentPage, this.sortBy);
    },
    async changePage222() {
      console.log('---------changePage222changePage222----------------------')
    },
    async getInfo(perPage, currentPage, sortBy) {
      this.loadingData = true;
      
      this.aid = this.accountId || await this.store.dispatch('getAccountId');
      if (this.customId) {
        this.aid = this.customId
      }

      return this.pos ? this.getPos(perPage, currentPage) : this.getInvoices(perPage, currentPage, sortBy);      
    },
    getPos(perPage, currentPage){
      if (!perPage)
        perPage = this.perPage;

      if (!currentPage)
        currentPage = this.currentPage;

      return this.store.dispatch('requestApi3', {
        path: `account/${this.aid}/pos/order?limit=${this.perPage}&page=${this.currentPage - 1}`,
        method: 'get'
      }).then(response => {

        if (response.data.success) {
          let downLine_ = response.data.payload.list;
          //add reactivity to nested objects
          // this.$set(this.downLine[0], 'm.Rank', this.downLine[0]['m.Rank']);
          this.totalRows = response.data.payload.total;
          if (this.tablePage === -1 && this.totalRows)
            this.tablePage = 1;
          this.dataFields = downLine_.map(v => {

            let data = [];

            if (v?.items.length) {
              v.items.forEach((item) => {
                data.push({
                  ['count']          : item.quantity,
                  ['g:availability'] : null, // ????
                  ['g:id']           : item.posCatalogItem.article,
                  ['g:image_link']   : item.posCatalogItem.imageUrl,
                  ['g:price']        : item.price,
                  ['g:priceF']       : item.price.toFixed(2) + ' ' + (item.currencyId || ''),
                  ['g:total']        : (item.price * item.quantity).toFixed(2) + ' ' + (item.currencyId || ''),
                  ['g:product_type'] : '', // ?????
                  ['g:pv']           : item.volume,
                  ['link']           : '',
                  ['title']          : item.posCatalogItem.title
                });
              })
            }

            // sum: "1350.00" возвращается null
            // items[0].posCatalogItem.imageUrl возвращается null

            return {
              currencyId     : v.currencyId,
              request_id     : v.number,
              request_date   : moment(v.createdAt.toString()).local(),
              amount         : v?.sum ? '-' + v.sum : '0', // сумма СТОЛБЕЦ
              sum            : v?.sum,
              payment_system : 'POS', // ????
              status         : v.documentStatus.title,
              status_code    : statusField.get(v.documentStatus.id.toString()),
              status_color   : v.documentStatus.color,
              data           : data,
              comment        : v.notice,
              delivery       : { 
                address  : v?.delivery?.adress,
                id       : v?.delivery?.id,
                price    : v?.delivery?.price || 0, // сумма доставки справа снизу - раскрыть
                title    : (v?.delivery?.title ? v.delivery.title : ' - '),
                title_   : (v?.delivery?.title ? v.delivery.title : ' - ') + ' (0.00 RUB)'
              },
              planProperties : {}
            };
          });

          console.log('this.dataFields !!!!', this.dataFields)
        }
        this.loading = false;
        this.loadingData = false;
      })
      .catch(() => {
        this.loading = true;
      });

    },
    getInvoices(perPage, currentPage, sortBy) {
      this.loadingData = true;
      if (!perPage)
        perPage = this.perPage;
      if (!currentPage)
        currentPage = this.currentPage;
      if (!sortBy)
        sortBy = this.sortBy;
      if (sortBy) {
        switch (sortBy) {
          case 'request_id':
            sortBy = '&orderBy[invoice.id]=DESC';
            break;
          case 'request_date':
            sortBy = '&orderBy[invoice.created_at]=DESC';
            break;
          case 'amount':
            sortBy = '&orderBy[invoice.buyer_amount]=DESC';
            break;
          case 'status':
            sortBy = '&orderBy[invoice.status]=DESC';
            break;
          default:
            sortBy = '';

        }
      }

      const perPageAndPageNum = `?page=${this.currentPage - 1}&limit=${this.perPage}`
      const walletId          = this.wallet != null ? `*s*&filter[*i*][field]=wallet-type.id&filter[*i*][value]=${this.wallet}&filter[*i*][operation]===` : ""
      const dateStart         = this.dateStart      ? `*s*&filter[*i*][field]=invoice.created_at&filter[*i*][value]=${this.dateStart}&filter[*i*][operation]=<=` + this.dateStart : ""
      const dateEnd           = this.dateEnd        ? `*s*&filter[*i*][field]=invoice.created_at&filter[*i*][value]=${this.dateEnd}&filter[*i*][operation]=>=` + this.dateEnd   : ""
      // const sortByText        = (sortBy             ? '&sortBy=' + (this.sortDesc ? '' : '-') + sortBy : '')

      let mapQuery = walletId + dateStart + dateEnd
      let resQuery = ''

      if (mapQuery) {
        mapQuery.split("*s*").forEach((prop, key) => {
          resQuery = resQuery + prop.replace(/(\*i\*)/g, key)
        })
      }

      // GET /api3/account/{id}/invoice
      return this.store.dispatch('requestApi3', {
        //path: `api2/main-app/account/get-invoice?accountId=${this.aid}${perPageAndPageNum}${dateStartEnd}${walletId}${sortByText}`,
        path: `account/${this.aid}/invoice${perPageAndPageNum}${resQuery}${sortBy}`,
        method: 'get'
      }).then(response => {
        if (response === 'loading') {
          this.loading = true;
          return 0;
        }
        if (response.data.success) {
          let downLine_ = response.data.payload.list;
          //add reactivity to nested objects
          // this.$set(this.downLine[0], 'm.Rank', this.downLine[0]['m.Rank']);
          this.totalRows = response.data.payload.total;
          if (this.tablePage === -1 && this.totalRows)
            this.tablePage = 1;
          this.dataFields = downLine_.map(v => {
            if (v['data'] && v['data']['items'] && !Array.isArray(v['data']['items'])){
              // v['data']['items']['g:id'] = '1';
              v['data']['items'] = [v['data']['items']];

            }

            return {
              currencyId: v['wallet'].currency_id,
              request_id: v['id'],
              request_date: moment(v['createdAt'].toString()).local(),
              amount: (-1 * v['buyerAmount']).toFixed(2).toString(),
              payment_system: this.showWallet ? (v['fillUp'] ? v['fillUp']['paymentSystem']['title'] : '-')+' / '+(v['fillUp'] && v['fillUp']['wallet'] ? v['fillUp']['wallet']['title'] : v['fillUp'] ? '-' : v['wallet']['title']) : (v['fillUp'] ? v['fillUp']['paymentSystem']['title']: '-'),
              status: statusField.get(v['status']) ? this.$t('message.'+statusField.get(v['status'])) : null,
              status_code: statusField.get(v['status']),
              data: v['data'] && v['data']['items'] ? v['data']['items'] : [],
              comment: v['comment'],
              delivery: v['data'] && v['data']['delivery'] ? v['data']['delivery'] : null,
              planProperties: v['changed_plan_properties'] ? v['changed_plan_properties'] : {}
            };
          });
        }
        this.loading = false;
        this.loadingData = false;
      })
      .catch(() => {
        this.loading = true;
      });
    }
  }
}
</script>
<style scoped>
@import '~vuetify/dist/vuetify.min.css';
@import './../../styles/projectStyles/vuetify/vuetify-del.css';
@import '~bootstrap/dist/css/bootstrap.min.css';
@import '~bootstrap-vue/dist/bootstrap-vue.min.css';
@import "./../../styles/monarch/elements/badges.css";
@import "./../../styles/monarch/helpers/boilerplate.css";
@import "./../../styles/monarch/helpers/utils.css";
@import "./../../styles/monarch/helpers/typography.css";
@import "./../../styles/monarch/helpers/grid.css";
@import "./../../styles/monarch/widgets/touchspin/touchspin.css";
@import "./../../styles/monarch/widgets/datatable/datatable.css";
@import "./../../styles/monarch/helpers/border-radius.css";
@import "./../../styles/monarch/elements/content-box.css";
@import "./../../styles/monarch/elements/social-box.css";
@import "./../../styles/monarch/themes/admin/color-schemes/default.css";
@import "./../../styles/monarch/themes/components/default.css";
@import "./../../styles/monarch/elements/buttons.css";
@import "./../../styles/monarch/helpers/colors.css";
@import "./../../styles/monarch/themes/components/border-radius.css";
@import "./../../styles/projectStyles/table/striped.css";
@import "./assets/online-order-history.css";
@import "./../../styles/projectStyles/body.css";
.rotate-leave-active {
  -webkit-transition: -webkit-transform .5s ease-in-out;
  -ms-transition: -ms-transform .5s ease-in-out;
  transition: transform .5s ease-in-out;
}
.rotate-leave-to
  /* .component-fade-leave-active до версии 2.1.8 */ {
  transform:rotate(-180deg);
  -ms-transform:rotate(-180deg);
  -webkit-transform:rotate(-180deg);
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}
</style>
